<template>
  <div class="yumui-alert-mask" v-show="visible">
    <div class="yum-alert amint">
      <div class="yum-header">温馨提示</div>
      <div class="yum-body">
        <div class="cont">
          <div style="flex: 1" v-for="item in chooses" @click="clickItem(item)">
            <img v-if="item.isSelect" src="./okIco.png" width="30px" style="vertical-align: middle;pointer-events: none;">
            <img v-if="!item.isSelect" src="./okIco1.png" width="30px" style="vertical-align: middle;pointer-events: none;">
            &nbsp;&nbsp; {{item.name}}
          </div>
        </div>
        <input type="text" v-if="id==0" v-model="tableNo" placeholder="请填写桌号或台号" class="input">
      </div>
      <div class="yum-footer">
        <button class="yum-button no" @click="no()">取消</button>
        <button class="yum-button ok" @click="ok()">支付</button>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    name: "isTakeOut",
    data(){
      return {
        visible: false,
        tableNo:"", //桌号
        id:0,        //选择堂食或者外卖  1 堂食 2外卖
        isChoose:false,    //点击取消或者支付  false  取消  true  支付
        chooses:[{
          name:'堂食',
          isSelect:true,
          id:0
        },{
          name:'外带',
          isSelect:false,
          id:1
        },],
        clicked : (res)=>{}
      }
    },


    methods:{

      init(){
       this.chooses.length = 0;
       this.chooses = [{
         name:'堂食',
         isSelect:true,
         id:0
       },{
         name:'外带',
         isSelect:false,
         id:1
       },]
      },

      clickItem(item){
        this.tableNo = '' ;
        this.chooses.forEach(choose=>{
          if(choose.id == item.id){
            choose.isSelect = true;
            this.id = item.id;
          }else {
            choose.isSelect = false;
          }
        })
      },


      no(){
        this.isChoose = false ;
        if(this.clicked){
          let  v = {
            id:this.id,
            tableNo: this.tableNo,
          } ;
          this.clicked(false,v);
          this.visible = false;
        }
      },
      ok(){
        if(this.clicked){
          this.isChoose = true ;
          let  v = {
            id:this.id,
            tableNo: this.tableNo,
          } ;
          this.clicked(true,v);
          this.visible = false;
        }
      }
    }
  }
</script>

<style scoped lang="scss">

  .amint{animation: bounce-in .2s;}
  @keyframes bounce-in {
    0% {transform: scale(0);}
    100% {transform: scale(1);}
  }

  .yumui-alert-mask {
    min-height: 100%;
    width: 100%;
    position: absolute;
    top: 0;
    left: 0;
    z-index: 99999;
    display: flex;
    justify-content: center;
    align-items: center;
    overflow: hidden;
    background: rgba(0,0,0,.3);
  }
  .yumui-alert-mask>.yum-alert{
    border-radius: 10px;
    background-color: #fff;
    width: 85%;
    font-size: 16px;
    overflow: hidden;
  }
  .yumui-alert-mask>.yum-alert>.yum-header{
    text-align: center;
    margin-bottom: 0;
    font-size: 16px;
    font-weight: 700;
    color: #333;
    padding:15px 0;
  }
  .yumui-alert-mask>.yum-alert>.yum-body{
    padding: 10px 20px 15px;
    border-bottom: 1px solid #ddd;
    min-height: 36px;
    text-align: center;
  }
  .yumui-alert-mask>.yum-alert>.yum-body>.cont{
    display: flex;
  }

  .yumui-alert-mask>.yum-alert>.yum-footer{
    display: flex;
    align-items: center;
    border-radius:10px;
  }
  .yumui-alert-mask>.yum-alert>.yum-footer>.yum-button{
    padding:12px 0;
    display: inline-block;
    text-align: center;
    font-size: 1em;
    background: #fff;
    border:none;
    flex: 1;
  }
  .yumui-alert-mask>.yum-alert>.yum-footer>.yum-button:first-child{
    border-right:1px solid #ddd;
    border-bottom-left-radius: 10px;
  }
  .input{
    outline:none;
    font-size: 16px;
    height: 30px;
    width: 80%;
    border-radius: 20px;
    text-align: center;
    border: 1px solid #e3e3e3;
    margin: 20px auto 3px auto;
  }
</style>



// WEBPACK FOOTER //
// src/components/isTakeOut/isTakeOut.vue